<template>
  <transition v-if="showModal" key="modal" name="modal">
    <div class="modal-mask finish-auctions-catalog-confirmation-modal">
      <div class="modal-wrapper">
        <div class="modal-container modal-center employees-modal">
            <button
              class="btn-oval btn-oval--transparent modal__close"
              @click="close"
            >
              <span class="icon icon-close-big"></span>
            </button>
            <p class="headings--h3">
              {{I18n.t('employees.auctions_catalogs.send_summary_emails_modal.title')}}
            </p>
            <p class="my-4">
              {{I18n.t('employees.auctions_catalogs.send_summary_emails_modal.body')}}
            </p>
            <div class="col-4 d-flex justify-content-between mt-3 mx-auto">
              <button @click="confirm()" class="btn btn__default">
                {{I18n.t('employees.auctions_catalogs.send_summary_emails_modal.confirm')}}
              </button>
              <button @click="close()" class="btn btn__default">
                {{I18n.t('employees.auctions_catalogs.send_summary_emails_modal.dismiss')}}
              </button>
            </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'SendSummaryEmailsModal',
    props: {
      auctionsCatalog: Object,
      showModal: Boolean,
    },
    methods: {
      ...mapActions('auctionsCatalogs', ['getAuctionsCatalogSendSummaryEmails']),
      confirm() {
        this.getAuctionsCatalogSendSummaryEmails([this.auctionsCatalog.id]);
        this.close();
      },
      close() {
        this.$emit('closeModal', false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/send_summary_emails_modal.vue?f8850db2